/**
 * DevExtreme (esm/renovation/utils/combine_classes.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function combineClasses(classesMap) {
    return Object.keys(classesMap).filter((p => classesMap[p])).join(" ")
}
